/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import MarkdownLayout from "components/MarkdownLayout";
import Button from "components/Button";
export const meta = {
  title: "Manifesto",
  desc: "Our stance on building Raycast."
};
const MDXLayout = ({children}) => _jsx(MarkdownLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    a: "a"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "In a time when we download new software every day, it’s important for us to take a step back and define what stance we take. This is a list of our philosophies."
    }), "\n", _jsx(_components.h2, {
      children: "We respect your privacy"
    }), "\n", _jsx(_components.p, {
      children: "No login is required to use Raycast. Everything you do in the app is anonymous and your data stays on your computer."
    }), "\n", _jsxs(_components.p, {
      children: ["The credentials for third party services are stored securely in your ", _jsx(_components.a, {
        href: "https://developer.apple.com/documentation/security/keychain_services",
        children: "Keychain"
      }), ". All extensions communicate directly via ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/HTTPS",
        children: "HTTPS"
      }), " over ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Transport_Layer_Security",
        children: "TLS"
      }), " to third party APIs. Raycast does not operate intermediary servers to process or store your data. We use ", _jsx(_components.a, {
        href: "https://oauth.net",
        children: "OAuth"
      }), " for authentication and authorization where possible and access as little information as necessary. Our databases are stored ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Advanced_Encryption_Standard",
        children: "encrypted"
      }), " on your local hard drive. None of the data fetched from third party services leaves your computer. Also, any data in an extension gets deleted when you log out."]
    }), "\n", _jsx(_components.p, {
      children: "We don’t track any sensitive data. Only completely anonymous usage statistics and error logging are sent to us. We interpret the usage data in order to improve Raycast. None of the data is sold, and we don’t use it for advertisement."
    }), "\n", _jsxs(_components.p, {
      children: ["For the legal bits, head over to our ", _jsx(_components.a, {
        href: "/privacy",
        children: "privacy policy"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "We build a business"
    }), "\n", _jsx(_components.p, {
      children: "We took on funding to hire the best people and build a company around developer productivity. Our vision is to establish an ecosystem and community of productivity tools paired with a clear business model."
    }), "\n", _jsx(_components.p, {
      children: "Raycast is free for personal use. We are working on paid features for teams. The clear monetization guarantees that we are able to maintain the tool and support the community."
    }), "\n", _jsx(_components.h2, {
      children: "We write native code"
    }), "\n", _jsx(_components.p, {
      children: "At its core, Raycast makes developers faster. We don’t want the computers to become the bottleneck. We built the app natively on top of Apple’s frameworks. Right now we only support macOS."
    }), "\n", _jsxs(_components.p, {
      children: ["By doing this, we deliver the best performance with the least amount of resources. In addition, we’re able to augment the operating system and adopt the platform-specific user experience. Eventually, we’ll expand to other systems with additional native clients. Custom extensions built with ", _jsx(_components.a, {
        href: "https://developers.raycast.com/",
        children: "our API"
      }), " will work on all clients in the same way."]
    }), "\n", _jsx(_components.h2, {
      children: "We grow a community"
    }), "\n", _jsxs(_components.p, {
      children: ["We put our ", _jsx(_components.a, {
        href: "https://www.raycast.com/community",
        children: "community"
      }), " first and provide them with the toolkit they need to build the productivity tools they desire."]
    }), "\n", _jsx(_components.p, {
      children: "We learned that a strong community can lift a product to the next level. Plus, we know that we can’t build all extensions ourselves. Every individual, team and organization has a different setup. Sometimes they are internal and are not always accessible to others. Our effort concentrates on establishing a community that can build the ecosystem of productivity tools they need."
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
